module.exports = __webpack_public_path__ + "img/Image_placeholder.2efb1268.png";